import React from 'react';
import PropTypes from 'prop-types';

const Paginator = ({
  setPageIndex,
  getCanPreviousPage,
  getCanNextPage,
  previousPage,
  nextPage,
  getPageCount,
  setPageSize,
  currentPageIndex,
  currentPageSize,
  pageSizes,
  rowCount,
}) => {
  return <div className='table-paginator'>
    <div className='h-2' />
    <div className='flex items-center justify-content-between'>
      <div className='flex items-center gap-2'>
        <div>Page</div>
        <strong>
          {currentPageIndex + 1} of{' '}
          {getPageCount()}
        </strong>
        <span className='mx-1'>|</span>
          Go to page:
        <input
          type='number'
          defaultValue={currentPageIndex + 1}
          onChange={(e) => {
            const page = e.target.value ? Number(e.target.value) - 1 : 0;
            setPageIndex(page);
          }}
          className='border p-1 rounded w-16 h-12'
        />
        <span className='mx-1'>|</span>
        <select
          className='border p-2 rounded h-12'
          value={currentPageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {pageSizes.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
                Show {pageSize}
            </option>
          ))}
        </select>
      </div>
      <div className='buttons'>
        <button
          onClick={() => setPageIndex(0)}
          disabled={!getCanPreviousPage()}
        >
          {'First'}
        </button>
        <button
          onClick={() => previousPage()}
          disabled={!getCanPreviousPage()}
        >
          {'Previous'}
        </button>
        <button
          onClick={() => nextPage()}
          disabled={!getCanNextPage()}
        >
          {'Next'}
        </button>
        <button
          onClick={() => setPageIndex(getPageCount() - 1)}
          disabled={!getCanNextPage()}
        >
          {'Last'}
        </button>
      </div>
    </div>
    {!!rowCount && <div>{rowCount} Rows</div>}
  </div>;
};

Paginator.propTypes = {
  setPageIndex: PropTypes.func,
  getCanPreviousPage: PropTypes.func,
  getCanNextPage: PropTypes.func,
  previousPage: PropTypes.func,
  nextPage: PropTypes.func,
  getPageCount: PropTypes.func,
  setPageSize: PropTypes.func,
  currentPageIndex: PropTypes.number,
  currentPageSize: PropTypes.number,
  pageSizes: PropTypes.array,
  rowCount: PropTypes.number,
};

Paginator.defaultProps = {
  pageSizes: [10, 25, 50, 100],
};

export default Paginator;
